import React from 'react';
import styled from 'styled-components';
import { GreaterThan } from '@peloton/responsive/helpers';
import { media } from '@peloton/styles/breakpoints';
import { black } from '@engage/colors/base';
import { spaces } from '@engage/styles/spaces';
import { label14 } from '@engage/typography/font-styles';
import { TopNavCopy, useAria } from '@members/copy/copy.generated';
import { Aria } from '@members/copy/models.generated/Aria';

import { TopNav } from '@members/copy/models.generated/TopNav';
import { useFeatureToggle } from '@members/feature-toggles/featureToggles';
import { Feature } from '@members/feature-toggles/toggles';
import { HOMESCREEN_ROUTE } from '@members/routes/homescreen';
import { MainLink, makeLinkActivatable } from '../../sharedLinkStyles';
import { ANALYTICS_SOURCE } from '../analytics';
import { PelotonLogo } from '../icons/PelotonLogo';

export const HomeLogoLink = () => {
  const navUpdatesEnabled = useFeatureToggle(Feature.Navupdates);
  const navBreakpoint = navUpdatesEnabled ? 'desktopLarge' : 'desktop';
  const pelotonHomeAriaLabel = useAria(Aria.PelotonHome);
  return (
    <ActivatableMainLink
      href={{
        pathname: HOMESCREEN_ROUTE,
        query: { source: ANALYTICS_SOURCE },
      }}
      alias={HOMESCREEN_ROUTE}
      data-test-id="homepageLink"
      aria-label={pelotonHomeAriaLabel}
    >
      <NavPelotonLogo />
      <GreaterThan breakpoint={navBreakpoint}>
        <TopNavCopy id={TopNav.Home} />
      </GreaterThan>
    </ActivatableMainLink>
  );
};
const NavPelotonLogo = styled(PelotonLogo)`
  fill: ${black};
  height: 32px;
  width: 23px;
  margin-left: 0px;
  ${media.tablet`
    height: 28px;
    width: ${spaces.large}px;
  `}
  ${media.desktopLarge`
    margin-right: ${spaces.small}px;
  `}
`;

const TopTextLink = styled(MainLink)`
  ${label14};
  margin-bottom: 0px;
  padding: 10px ${spaces.medium}px;
  border-radius: 4px;
`;

const ActivatableMainLink = makeLinkActivatable(TopTextLink);
